import React from 'react';
import { useParams } from 'react-router-dom';
import VehicleForm from './VehicleForm.js';

export default function EditVehicleForGroup() {
  const { id, vehicleId } = useParams();
  return <VehicleForm id={Number(vehicleId)} groupId={Number(id)} />;
}
